import {connect} from "react-redux";
import ObjectAddNew from "./ObjectAddNew";
import {compose} from "redux";
import {WithAppendHeaderAndFooterHOC} from "../../HOC/WithAppendHeaderAndFooterHOC";
import {WithAppendSidebarHOC} from "../../HOC/WithAppendSidebarHOC";
import {geoCode, getCities, getCountries, getTypes} from "./actions";
import {addObject, getChannelManagerList} from "../../globalState/object/actions";
import {WithSavingSnackBar} from "../../HOC/WithSavingSnackBar";



let mapStateToProps = (state) => {

    return {
        objectTypes: state.objectAddNew.objectTypes,
        countries: state.objectAddNew.countries,
        cities: state.objectAddNew.cities,
        addresses: state.objectAddNew.addresses,
        newObjectId: state.object.newObjectId,
        email: state.user.email,
        personalMobile: state.user.personalMobile,
        verified: state.user.verified,
        channelManagerList: state.object.channelManagers,

    }

};

let mapDispatchToProps = (dispatch) => {
    return {}
};

export default compose(connect(mapStateToProps, {
    mapDispatchToProps,
    getTypes,
    getCountries,
    getCities,
    geoCode,
    addObject,
}), WithAppendHeaderAndFooterHOC, WithAppendSidebarHOC, WithSavingSnackBar)(ObjectAddNew);



